import { ASTRO1_CONTEXT } from '@/constants/context';
import { VIDEO_URLS } from '@/constants/videos';
import React from 'react';

const AstroOne = () => {
  return (
    <div
      id='content-AstroOne'
      className='w-full h-full flex flex-col box-border gap-4 xl:gap-6'
    >
      <div className='flex flex-col gap-4 md:gap-6 xl:w-[530px] xl:h-[400px] md:h-[350px] h-[642px]'>
        <div className='w-full flex flex-col justify-start px-4 md:px-0'>
          <h1 className='leading-7 md:leading-8 text-4xl md:text-4xl font-bold text-white text-left'>
            <strong>
              Astro-<span className='text-[#fccb15]'>1</span>
            </strong>
          </h1>
        </div>
        <div className='border-l-4 border-[#FCCB16] md:pl-3 ml-4 md:ml-0'>
          <div className='text-base md:text-xl font-semibold text-white px-4 md:px-0'>
            {ASTRO1_CONTEXT.SUBTITLE}
          </div>
        </div>
        <div className='w-full flex justify-start items-start px-4 md:px-0'>
          <section className='w-full flex justify-start'>
            <div className='text-sm md:text-lg font-medium text-white md:text-justify xl:hidden'>
              {ASTRO1_CONTEXT.DESCRIPTION}
            </div>
            <div className='hidden xl:block text-lg font-medium text-white'>
              {ASTRO1_CONTEXT.DESCRIPTION[0].split('sustainable space.').map((part, index) => (
                <p key={index}>
                  {index === 0 ? part + 'sustainable space.' : part.trim()}
                </p>
              ))}
            </div>
          </section>
        </div>
        <div className='md:hidden relative w-[calc(100%+2rem)] h-[319px] overflow-hidden rounded-lg -mx-4'>
          <video
            className='absolute inset-0 w-full h-full object-cover pointer-events-none'
            controls={false}
            disablePictureInPicture
            playsInline
            onContextMenu={e => e.preventDefault()}
            muted
            autoPlay
            loop
          >
            <source src={VIDEO_URLS.ASTRO_1} />
          </video>
        </div>
      </div>

      {/* Mobile & Tablet Video */}
      <div className='xl:hidden hidden md:block relative w-full h-[250px] md:h-[390px] md:w-[688px] overflow-hidden rounded-lg'>
        <video
          className='absolute w-full h-full object-cover pointer-events-none '
          controls={false}
          disablePictureInPicture
          playsInline
          onContextMenu={e => e.preventDefault()}
          muted
          autoPlay
          loop
        >
          <source src={VIDEO_URLS.ASTRO_1} />
        </video>
      </div>

      {/* Desktop Video */}
      <video
        className='hidden xl:block absolute bottom-[20%] left-[60%] w-[400px] h-[400px] object-cover pointer-events-none z-[-100]'
        muted
        autoPlay
        loop
        controls={false}
        disablePictureInPicture
        playsInline
        onContextMenu={e => e.preventDefault()}
      >
        <source src={VIDEO_URLS.ASTRO_1} />
      </video>
    </div>
  );
};

export default React.memo(AstroOne);
